var _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5C0 10.1863 2.68629 7.5 6 7.5H42C45.3137 7.5 48 10.1863 48 13.5V34.5C48 37.8137 45.3137 40.5 42 40.5H6C2.68629 40.5 0 37.8137 0 34.5V13.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 8.5H6C3.23858 8.5 1 10.7386 1 13.5V34.5C1 37.2614 3.23858 39.5 6 39.5H42C44.7614 39.5 47 37.2614 47 34.5V13.5C47 10.7386 44.7614 8.5 42 8.5ZM6 7.5C2.68629 7.5 0 10.1863 0 13.5V34.5C0 37.8137 2.68629 40.5 6 40.5H42C45.3137 40.5 48 37.8137 48 34.5V13.5C48 10.1863 45.3137 7.5 42 7.5H6Z",
    fill: "#E4E4E4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.5469,
    y: 17.0059,
    width: 8.92256,
    height: 14.7382,
    fill: "#F26122"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5082 24.375C20.4934 21.5065 21.7821 18.7899 24.0038 17.0059C20.2025 13.9834 14.7421 14.4223 11.4609 18.0141C8.1797 21.6058 8.1797 27.1442 11.4609 30.7359C14.7421 34.3277 20.2025 34.7666 24.0038 31.7441C21.7821 29.9601 20.4934 27.2435 20.5082 24.375Z",
    fill: "#EA1D25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 24.375C38.9978 27.9618 36.9716 31.2329 33.781 32.8007C30.5904 34.3686 26.7947 33.9584 24.0039 31.7441C28.0239 28.5437 28.7201 22.6558 25.5595 18.5875C25.1064 17.9984 24.584 17.4673 24.0039 17.0059C26.7947 14.7916 30.5904 14.3814 33.781 15.9493C36.9716 17.5171 38.9978 20.7882 39.0001 24.375Z",
    fill: "#F69E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.49edab77424e65c629c7e90352304ff3.svg";
export { ForwardRef as ReactComponent };